// * @author: YiuHai
// * @Date: 2022-03-14 16:56:05
// * @description: 一些描述
// * @LastEditors: YiuHai
// * @LastEditTime: 2022-03-15 10:34:53
// * @FilePath: /app1/src/views/retureBoard/component/finish

import boardBox from "./boardBox.vue";
export default {
  props: { boardData: { type: Object, default: () => {} } },
  components: { boardBox },
  render(h) {
    const { boardData } = this;
    return h("div", [
      h(boardBox, {
        props: {
          width: "244px",
          title: "已退费工单数",
          unit: "单",
          hint: "所选时间段内已完成退费的工单数量",
          tagColor: "#46ADAA",
          basisV: boardData ? boardData.alreadyInfo.baseNum : 0,
          vipV: boardData ? boardData.alreadyInfo.vipNum : 0,
          countV: boardData ? boardData.alreadyInfo.num : 0,
        },
      }),
      h(boardBox, {
        props: {
          width: "244px",
          title: "已退费金额",
          unit: "元",
          hint: "所选时间段内已完成退费的退费总金额",
          tagColor: "#46ADAA",
          basisV: boardData ? boardData.alreadyInfo.basePayAmt : 0,
          vipV: boardData ? boardData.alreadyInfo.vipPayAmt : 0,
          countV: boardData ? boardData.alreadyInfo.payAmt : 0,
        },
      }),
    ]);
  },
};
